import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function FutureCollaborations() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="2220" id="transparency-matters" ref={sectionRef} className="bg-background text-secondary relative flex min-h-[60vh] w-full flex-col items-center justify-center overflow-hidden py-32 md:py-40">
      {}
      <div className="pointer-events-none absolute inset-0 z-0 opacity-5 mix-blend-multiply">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0IiBoZWlnaHQ9IjQiPgo8cmVjdCB3aWR0aD0iNCIgaGVpZ2h0PSI0IiBmaWxsPSIjZmZmIi8+CjxyZWN0IHdpZHRoPSIxIiBoZWlnaHQ9IjEiIGZpbGw9IiMwMDAiLz4KPC9zdmc+')] [mask-image:linear-gradient(to_bottom,transparent,black)]" />
      </div>

      {}
      <div className="absolute top-1/2 left-1/2 -z-10 h-[500px] w-[500px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-secondary/5 blur-[120px]" />

      <div className="container relative z-10 mx-auto flex flex-col items-center px-4 text-center">
        {}
        <h2 className={cn("font-sans text-5xl font-extrabold tracking-tighter uppercase transition-all duration-1000 md:text-[84px] md:leading-tight", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
          <span className="block text-secondary">Transparency is the</span>
          <span className="block text-transparent [-webkit-text-stroke:1px_hsl(var(--secondary))] md:[-webkit-text-stroke:2px_hsl(var(--secondary))]">
            First Step Toward Fairness
          </span>
        </h2>

        {}
        <p className={cn("mt-6 max-w-2xl text-lg text-secondary/80 transition-all delay-200 duration-1000 md:text-xl font-medium", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
          We are exposing the systemic flaws in New York&apos;s property tax assessments. Stay updated on our latest investigations and help us demand a more equitable system.
        </p>

        {}
        <div className={cn("mt-12 transition-all delay-400 duration-1000", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
          <Link to="#">
            
          </Link>
        </div>
      </div>
    </section>;
}